import { Button, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { X } from "lucide-react";
import type { FC, FormEventHandler, PropsWithChildren } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

const HEADER_MIN_HEIGHT = 52;

type Props = {
	open: boolean;
	title: string;
	submitLabel: string;
	submitDisabled?: boolean;
	onClose: () => void;
	onSubmit: FormEventHandler<HTMLFormElement>;
};

export const FormSheet: FC<PropsWithChildren<Props>> = ({
	open,
	title,
	submitLabel,
	submitDisabled = false,
	onClose,
	onSubmit,
	children,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<MyPlannDrawer
			grabber={false}
			open={open}
			onClose={onClose}
			paperSx={{ backgroundColor: theme.palette.background.paper }}
			header={
				<Stack
					direction="row"
					alignItems="center"
					gap={theme.spacingTokens.sm}
					flexShrink={0}
					minHeight={HEADER_MIN_HEIGHT}
					px={theme.spacingTokens.md}
					py={theme.spacingTokens.sm}
					borderBottom={theme.colors.border.flatRowDivider}
				>
					<IconButton
						variant="header"
						onClick={onClose}
						aria-label={t(Resources.Common.Cancel)}
					>
						<X size={theme.iconSize.md} color={theme.palette.grey[500]} />
					</IconButton>
					<Typography variant="h4">{title}</Typography>
				</Stack>
			}
		>
			<Stack component="form" onSubmit={onSubmit}>
				<Stack
					px={theme.spacingTokens.lg}
					pt={theme.spacingTokens.lg}
					pb={theme.spacingTokens.sm}
					gap={theme.spacingTokens.lg}
				>
					{children}
				</Stack>
				<Stack
					px={theme.spacingTokens.lg}
					pt={theme.spacingTokens.sm}
					pb={theme.spacingTokens.section}
				>
					<Button variant="primary" type="submit" disabled={submitDisabled}>
						{submitLabel}
					</Button>
				</Stack>
			</Stack>
		</MyPlannDrawer>
	);
};
